/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BudgetPage_project$ref = any;
type expensesPage_project$ref = any;
type ratesAndInternalCostPage_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "CAPPED" | "FIXED_PRICE" | "UNCAPPED" | "%future added value";
export type UpdateProjectInput = {|
  id?: ?string,
  name?: ?string,
  description?: ?string,
  status?: ?string,
  active?: ?boolean,
  projectColor?: ?string,
  customProjectId?: ?string,
  clientId?: ?string,
  projectOwner?: ?string,
  projectManagers?: ?$ReadOnlyArray<?string>,
  statusColumns?: ?$ReadOnlyArray<?StatusColumnInput>,
  estimationUnit?: ?string,
  sprintTimeBox?: ?boolean,
  sprintLengthInDays?: ?number,
  projectStartYear?: ?number,
  projectStartMonth?: ?number,
  projectStartDay?: ?number,
  projectEndYear?: ?number,
  projectEndMonth?: ?number,
  projectEndDay?: ?number,
  taskLevels?: ?number,
  useTaskHierarchy?: ?boolean,
  rateCardId?: ?string,
  labels?: ?$ReadOnlyArray<?string>,
  minutesPerEstimationPoint?: ?number,
  budget?: ?number,
  budgetType?: ?BUDGET_TYPE,
  defaultPeriodPriceAmount?: ?number,
  defaultPeriodHoursAmount?: ?number,
  defaultPeriodBudgetType?: ?PERIOD_BUDGET_TYPE,
  defaultPeriodLength?: ?number,
  defaultPeriodPeriodicity?: ?PERIODICITY,
  defaultPeriodSettingIgnoreForBilling?: ?boolean,
  defaultPeriodSettingSubtractValue?: ?boolean,
  defaultPeriodSettingRollValue?: ?boolean,
  defaultPeriodSettingAddExpenses?: ?boolean,
  revenueMarginLow?: ?number,
  revenueMarginHigh?: ?number,
  economicProjectId?: ?string,
  harvestProjectId?: ?string,
  newHarvestProjectId?: ?string,
  jiraProjectId?: ?string,
  jiraCutoffDate?: ?string,
  excludedHarvestTasks?: ?$ReadOnlyArray<?string>,
  newExcludedHarvestTasks?: ?$ReadOnlyArray<?number>,
  timelogProjectId?: ?string,
  newTimelogProjectId?: ?string,
  initTaskImport?: ?boolean,
  slackChannelId?: ?string,
  approveNoPhaseTasks?: ?boolean,
  billable?: ?boolean,
  projectGroupId?: ?string,
  previousProjectGroupId?: ?string,
  salesforceOpportunity?: ?string,
  unit4Project?: ?string,
  githubRepositories?: ?$ReadOnlyArray<?string>,
  githubRepositoryIds?: ?$ReadOnlyArray<?number>,
  remainingAutoCalculated?: ?boolean,
  useManualAllocations?: ?boolean,
  taskCostCalculationType?: ?string,
  unassignedTaskHourlyCost?: ?number,
  useTaskOwner?: ?boolean,
  useTaskFollowers?: ?boolean,
  currencyExchangeRate?: ?number,
  fixedPriceRateCardSetting?: ?number,
  usePublicCreateTaskPage?: ?boolean,
  usePublicCreateTaskPassword?: ?boolean,
  publicCreateTaskPassword?: ?string,
  publicCreateTaskPageStatusColumnId?: ?string,
  unsynchedJiraProject?: ?boolean,
  useBaseline?: ?boolean,
  synchBaselineAndScopingDates?: ?boolean,
  useFixedPriceForBaselineRevenue?: ?boolean,
  useDeliverables?: ?boolean,
  synchDatesSetting?: ?string,
  baselineWinChance?: ?number,
  baselineTarget?: ?number,
  priorityLevelId?: ?string,
  manualProgressOnProjectEnabled?: ?boolean,
  manualProgressOnPhasesEnabled?: ?boolean,
  manualProgressOnTasksEnabled?: ?boolean,
  flatRate?: ?number,
  flatCost?: ?number,
  financialSourceSettings?: ?FinancialSourceSettingsInput,
  sageProjectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type StatusColumnInput = {|
  id?: ?string,
  name?: ?string,
  order?: ?number,
  category?: ?string,
  projectId?: ?string,
  projectGroupStatusColumnId?: ?number,
  autoShowOnTimePage?: ?boolean,
  encourageTimeRegistration?: ?boolean,
|};
export type FinancialSourceSettingsInput = {|
  plannedHours?: ?string,
  plannedRevenue?: ?string,
  plannedCost?: ?string,
  forecastHours?: ?string,
  forecastRevenue?: ?string,
  forecastCost?: ?string,
  actualHours?: ?string,
  actualRevenue?: ?string,
  actualCost?: ?string,
|};
export type updateProjectBudgetPageMutationModernMutationVariables = {|
  input: UpdateProjectInput
|};
export type updateProjectBudgetPageMutationModernMutationResponse = {|
  +updateProject: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +project: ?{|
      +id: string,
      +estimationUnit: ?string,
      +useBaseline: ?boolean,
      +projectStartYear: ?number,
      +projectStartMonth: ?number,
      +projectStartDay: ?number,
      +projectEndYear: ?number,
      +projectEndMonth: ?number,
      +projectEndDay: ?number,
      +companyProjectId: ?number,
      +warnings: ?$ReadOnlyArray<?{|
        +id: ?string,
        +year: ?number,
        +month: ?number,
        +day: ?number,
        +tasks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: ?string,
              +startDay: ?number,
              +startMonth: ?number,
              +startYear: ?number,
              +deadlineDay: ?number,
              +deadlineMonth: ?number,
              +deadlineYear: ?number,
              +estimateForecast: ?number,
            |}
          |}>
        |},
        +personIds: ?$ReadOnlyArray<?string>,
        +expenseItems: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: ?string,
              +expenseYear: ?number,
              +expenseMonth: ?number,
              +expenseDay: ?number,
            |}
          |}>
        |},
        +timeRegistrations: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +year: ?number,
              +month: ?number,
              +day: ?number,
              +minutesRegistered: ?number,
              +person: ?{|
                +id: string,
                +fullName: ?string,
                +profilePictureId: ?string,
                +profilePictureDefaultId: ?number,
              |},
              +task: ?{|
                +name: ?string
              |},
            |}
          |}>
        |},
      |}>,
      +$fragmentRefs: BudgetPage_project$ref & expensesPage_project$ref & ratesAndInternalCostPage_project$ref,
    |},
    +program: ?{|
      +id: string,
      +name: ?string,
      +prefix: ?string,
      +budgetType: ?PROGRAM_BUDGET_TYPE,
      +projects: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +serviceCompanyId: ?number,
            +companyProjectId: ?number,
            +name: ?string,
            +prefix: ?string,
            +budgetType: ?BUDGET_TYPE,
            +budget: ?number,
            +defaultPeriodBudgetType: ?PERIOD_BUDGET_TYPE,
            +financialNumbers: ?{|
              +allActualTimeAndExpenses: ?number,
              +recognitionProfitPercentage: ?number,
              +allTotalTimeAndExpensesAtCompletion: ?number,
              +forecastCostToComplete: ?number,
            |},
            +financialNumbersToDate: ?{|
              +recognitionActualProfitPercentage: ?number,
              +allActualTimeAndExpenses: ?number,
            |},
            +totalRevenueRecognition: ?number,
            +totalRevenueRecognitionToDate: ?number,
            +totalTimeRevenueRecognitionToDate: ?number,
            +totalBillableExpensesAtCompletion: ?number,
          |}
        |}>
      |},
      +projectsFinancialsTotals: ?{|
        +recognitionForecastRevenue: ?number,
        +allActualTimeAndExpenses: ?number,
        +allTotalTimeAndExpensesAtCompletion: ?number,
        +recognitionProfitPercentage: ?number,
        +recognitionActualProfitPercentage: ?number,
      |},
      +projectsFinancialsToDate: ?{|
        +totalActualRevenueRecognition: ?number,
        +recognitionAmount: ?number,
        +recognitionActualProfitPercentage: ?number,
        +allActualTimeAndExpenses: ?number,
      |},
    |},
  |}
|};
export type updateProjectBudgetPageMutationModernMutation = {|
  variables: updateProjectBudgetPageMutationModernMutationVariables,
  response: updateProjectBudgetPageMutationModernMutationResponse,
|};
*/


/*
mutation updateProjectBudgetPageMutationModernMutation(
  $input: UpdateProjectInput!
) {
  updateProject(input: $input) {
    errors
    project {
      id
      estimationUnit
      useBaseline
      projectStartYear
      projectStartMonth
      projectStartDay
      projectEndYear
      projectEndMonth
      projectEndDay
      companyProjectId
      warnings {
        id
        year
        month
        day
        tasks(first: 10000) {
          edges {
            node {
              id
              name
              startDay
              startMonth
              startYear
              deadlineDay
              deadlineMonth
              deadlineYear
              estimateForecast
            }
          }
        }
        personIds
        expenseItems(first: 10000) {
          edges {
            node {
              id
              name
              expenseYear
              expenseMonth
              expenseDay
            }
          }
        }
        timeRegistrations(first: 10000) {
          edges {
            node {
              id
              year
              month
              day
              minutesRegistered
              person {
                id
                fullName
                profilePictureId
                profilePictureDefaultId
              }
              task {
                name
                id
              }
            }
          }
        }
      }
      ...BudgetPage_project
      ...expensesPage_project
      ...ratesAndInternalCostPage_project
    }
    program {
      id
      name
      prefix
      budgetType
      projects(first: 10000) {
        edges {
          node {
            id
            serviceCompanyId
            companyProjectId
            name
            prefix
            budgetType
            budget
            defaultPeriodBudgetType
            financialNumbers {
              allActualTimeAndExpenses
              recognitionProfitPercentage
              allTotalTimeAndExpensesAtCompletion
              forecastCostToComplete
            }
            financialNumbersToDate {
              recognitionActualProfitPercentage
              allActualTimeAndExpenses
            }
            totalRevenueRecognition
            totalRevenueRecognitionToDate
            totalTimeRevenueRecognitionToDate
            totalBillableExpensesAtCompletion
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      projectsFinancialsTotals {
        recognitionForecastRevenue
        allActualTimeAndExpenses
        allTotalTimeAndExpensesAtCompletion
        recognitionProfitPercentage
        recognitionActualProfitPercentage
      }
      projectsFinancialsToDate {
        totalActualRevenueRecognition
        recognitionAmount
        recognitionActualProfitPercentage
        allActualTimeAndExpenses
      }
    }
  }
}

fragment ActualDetailsTable_project on ProjectType {
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...DetailsTable_project
}

fragment BudgetData_project_1TK8ll on ProjectType {
  ...Chart_project
  ...HighLevelBudgetNumbers_project_1TK8ll
  ...Totals_project
  ...InvoiceChart_project
  ...RevenueRecognition_project
  id
  billable
  budgetType
}

fragment BudgetPageHeader_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  budgetType
  budget
  defaultPeriodBudgetType
  rateCard {
    currency
    id
  }
  estimationUnit
  billable
  manualProgressOnProjectEnabled
  manualProgressOnPhasesEnabled
  manualProgressOnTasksEnabled
}

fragment BudgetPage_project on ProjectType {
  id
  financialDataAvailability
  ...BudgetPageHeader_project
  ...BudgetData_project_1TK8ll
  ...TimeBudgetData_project_1TK8ll
  ...Details_project
  ...InvoiceDetails_project
  ...TimeDetails_project
  ...ExpenseDetails_project
  manualProgressOnProjectEnabled
  manualProgressOnPhasesEnabled
  manualProgressOnTasksEnabled
  budgetType
}

fragment Chart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment DetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment Details_project on ProjectType {
  id
  useBaseline
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  estimationUnit
  billable
  ...DetailsTable_project
  ...ActualDetailsTable_project
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment ExpenseDetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment ExpenseDetails_project on ProjectType {
  id
  useBaseline
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  billable
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
  ...ExpenseDetailsTable_project
}

fragment HighLevelBudgetNumbers_project_1TK8ll on ProjectType {
  id
  useBaseline
  hasInvoices
  budget
  budgetType
  defaultPeriodBudgetType
  timeRegBasedPlusDoneScopeCompletion
  rateCard {
    currency
    id
  }
  financialNumbers(convertToProjectCurrency: true) {
    baselineRevenue
    actualRevenue
    baselineProfit
    actualProfit
    totalRevenueProfitAtCompletion
    baselineMargin
    actualMargin
    totalRevenueMarginAtCompletion
    billableActualTimeAndExpenses
    actualCost
    billableForecastTimeAndExpensesToComplete
    forecastCostToComplete
    totalCostAtCompletion
    billableTotalTimeAndExpensesAtCompletion
    invoiced
    paid
    recognitionProfit
    recognitionProfitPercentage
    totalRevenueRecognition
    projectTotalForecastTimeAndExpensesToCompleteInPast
    projectTotalForecastCostToCompleteInPast
    baselineCost
    baselineVsForecastCost
    allActualTimeAndExpenses
    allForecastTimeAndExpensesToComplete
    allTotalTimeAndExpensesAtCompletion
    baselineTimeAndExpenses
    baselineVsBillableTotalTimeAndExpensesAtCompletion
    estimatedCost
    planVsTotalCostAtCompletion
    billablePlannedTimeAndExpenses
  }
  financialNumbersToCurrentMonth: financialNumbers(convertToProjectCurrency: true) {
    recognitionLockedProfit
    recognitionLockedProfitPercentage
    recognitionLockedRevenue
  }
  expenseItems(first: 10000) {
    edges {
      node {
        approved
        billable
        partOfFixedPrice
        expenseYear
        expenseMonth
        expenseDay
        price
        cost
        quantity
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment HighLevelTimeNumbers_project_1TK8ll on ProjectType {
  id
  useBaseline
  billable
  financialNumbersToCurrentMonth: financialNumbers(convertToProjectCurrency: true) {
    registeredMinutes
    billableActualMinutes
    nonBillableActualMinutes
    forecastMinutes
    baselineMinutes
    scopeApprovedMinutes
    projectedTotalMinutes
    projectedBillableMinutes
    projectedNonBillableMinutes
  }
}

fragment InvoiceChart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment InvoiceDetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment InvoiceDetails_project on ProjectType {
  ...InvoiceDetailsTable_project
  budgetType
}

fragment RevenueRecognition_project on ProjectType {
  id
  budgetType
  billable
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  projectRevRecFirstDateYear
  projectRevRecFirstDateMonth
  projectRevRecFirstDateDay
  projectRevRecLastDateYear
  projectRevRecLastDateMonth
  projectRevRecLastDateDay
  estimationUnit
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        locked
        startDate
        endDate
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  rateCard {
    currency
    id
  }
}

fragment TimeBudgetData_project_1TK8ll on ProjectType {
  ...TimeChart_project
  ...TimeTotals_project
  ...HighLevelTimeNumbers_project_1TK8ll
}

fragment TimeChart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment TimeDetails_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  ...DetailsTable_project
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment TimeTotals_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment Totals_project on ProjectType {
  id
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  estimationUnit
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
  useFixedPriceForBaselineRevenue
}

fragment expenseRow_project on ProjectType {
  id
  budgetType
  companyProjectId
}

fragment expensesPage_project on ProjectType {
  ...expenseRow_project
  id
  companyProjectId
  billable
  budgetType
  status
  rateCard {
    id
    currency
  }
  expenseItems(first: 10000) {
    edges {
      node {
        id
        category {
          id
          name
        }
        phase {
          id
          name
        }
        name
        approved
        expenseYear
        expenseMonth
        expenseDay
        billable
        partOfFixedPrice
        price
        cost
        quantity
        planned
        createdAt
        invoiced
        person {
          id
          fullName
          profilePictureId
          profilePictureDefaultId
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        locked
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ratesAndInternalCostPage_project on ProjectType {
  id
  budget
  budgetType
  taskCostCalculationType
  unassignedTaskHourlyCost
  projectPersons(first: 1000) {
    edges {
      node {
        id
        person {
          id
          isViewer
          fullName
          initials
          profilePictureId
          profilePictureDefaultId
          active
          permissions
          costPeriods(first: 10000) {
            edges {
              node {
                id
                startDay
                startMonth
                startYear
                cost
              }
            }
          }
        }
        role {
          id
          name
        }
      }
    }
  }
  rateCard {
    id
    currency
    name
    defaultRate
    parentRateCardId
    disabledRoles {
      id
    }
    rates(first: 10000) {
      edges {
        node {
          id
          rate
          defaultRate
          startDate
          role {
            id
            name
          }
        }
      }
    }
  }
  invoices(first: 100000000) {
    edges {
      node {
        status
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBaseline",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "TaskTypeConnection",
  "kind": "LinkedField",
  "name": "tasks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimateForecast",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tasks(first:10000)"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personIds",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseYear",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseMonth",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseDay",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "ExpenseItemTypeConnection",
  "kind": "LinkedField",
  "name": "expenseItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseItemTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v17/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "expenseItems(first:10000)"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultPeriodBudgetType",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allActualTimeAndExpenses",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionProfitPercentage",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecastCostToComplete",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionActualProfitPercentage",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRevenueRecognition",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectServiceProjectTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProjectType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCompanyId",
            "storageKey": null
          },
          (v12/*: any*/),
          (v17/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbers",
            "plural": false,
            "selections": [
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbersToDate",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalTimeRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalBillableExpensesAtCompletion",
            "storageKey": null
          },
          (v42/*: any*/)
        ],
        "storageKey": null
      },
      (v43/*: any*/)
    ],
    "storageKey": null
  },
  (v44/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsTotals",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionForecastRevenue",
      "storageKey": null
    },
    (v36/*: any*/),
    (v38/*: any*/),
    (v37/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsToDate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalActualRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionAmount",
      "storageKey": null
    },
    (v40/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v50 = [
  (v3/*: any*/),
  (v17/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v53 = [
  {
    "kind": "Literal",
    "name": "convertToProjectCurrency",
    "value": true
  }
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v58 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectBudgetPageMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectFinancialWarningType",
                "kind": "LinkedField",
                "name": "warnings",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v27/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "timeRegistrations(first:10000)"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BudgetPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "expensesPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ratesAndInternalCostPage_project"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v17/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": "projects",
                "args": null,
                "concreteType": "ProjectServiceProjectTypeConnection",
                "kind": "LinkedField",
                "name": "__Program_projects_connection",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": null
              },
              (v46/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectBudgetPageMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectFinancialWarningType",
                "kind": "LinkedField",
                "name": "warnings",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v27/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "timeRegistrations(first:10000)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialDataAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentRateCardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "RateTypeConnection",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Rate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rate",
                                "storageKey": null
                              },
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v51/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "rates(first:10000)"
                  }
                ],
                "storageKey": null
              },
              (v52/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRegBasedPlusDoneScopeCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v53/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  (v39/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastTimeAndExpensesToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastCostToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsForecastCost",
                    "storageKey": null
                  },
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": "financialNumbersToCurrentMonth",
                "args": (v53/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ExpenseItemTypeConnection",
                "kind": "LinkedField",
                "name": "expenseItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseItemTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partOfFixedPrice",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "price",
                            "storageKey": null
                          },
                          (v57/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExpenseCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v50/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": (v50/*: any*/),
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planned",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "expenseItems(first:10000)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_expenseItems",
                "kind": "LinkedHandle",
                "name": "expenseItems"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v58/*: any*/),
                "concreteType": "ProjectFixedPriceLockTypeConnection",
                "kind": "LinkedField",
                "name": "fixedPriceLocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectFixedPriceLockTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectFixedPriceLockType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locked",
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "fixedPriceLocks(first:1000)"
              },
              {
                "alias": null,
                "args": (v58/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_fixedPriceLocks",
                "kind": "LinkedHandle",
                "name": "fixedPriceLocks"
              },
              (v59/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v58/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v16/*: any*/),
                                "concreteType": "CostPeriodTypeConnection",
                                "kind": "LinkedField",
                                "name": "costPeriods",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CostPeriodTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CostPeriod",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v57/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "costPeriods(first:10000)"
                              }
                            ],
                            "storageKey": null
                          },
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100000000
                  }
                ],
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v59/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v17/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ProjectServiceProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": "projects(first:10000)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Program_projects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              (v46/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "program",
            "projects"
          ]
        }
      ]
    },
    "name": "updateProjectBudgetPageMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectBudgetPageMutationModernMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    errors\n    project {\n      id\n      estimationUnit\n      useBaseline\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      companyProjectId\n      warnings {\n        id\n        year\n        month\n        day\n        tasks(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              startDay\n              startMonth\n              startYear\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              estimateForecast\n            }\n          }\n        }\n        personIds\n        expenseItems(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              expenseYear\n              expenseMonth\n              expenseDay\n            }\n          }\n        }\n        timeRegistrations(first: 10000) {\n          edges {\n            node {\n              id\n              year\n              month\n              day\n              minutesRegistered\n              person {\n                id\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n              }\n              task {\n                name\n                id\n              }\n            }\n          }\n        }\n      }\n      ...BudgetPage_project\n      ...expensesPage_project\n      ...ratesAndInternalCostPage_project\n    }\n    program {\n      id\n      name\n      prefix\n      budgetType\n      projects(first: 10000) {\n        edges {\n          node {\n            id\n            serviceCompanyId\n            companyProjectId\n            name\n            prefix\n            budgetType\n            budget\n            defaultPeriodBudgetType\n            financialNumbers {\n              allActualTimeAndExpenses\n              recognitionProfitPercentage\n              allTotalTimeAndExpensesAtCompletion\n              forecastCostToComplete\n            }\n            financialNumbersToDate {\n              recognitionActualProfitPercentage\n              allActualTimeAndExpenses\n            }\n            totalRevenueRecognition\n            totalRevenueRecognitionToDate\n            totalTimeRevenueRecognitionToDate\n            totalBillableExpensesAtCompletion\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      projectsFinancialsTotals {\n        recognitionForecastRevenue\n        allActualTimeAndExpenses\n        allTotalTimeAndExpensesAtCompletion\n        recognitionProfitPercentage\n        recognitionActualProfitPercentage\n      }\n      projectsFinancialsToDate {\n        totalActualRevenueRecognition\n        recognitionAmount\n        recognitionActualProfitPercentage\n        allActualTimeAndExpenses\n      }\n    }\n  }\n}\n\nfragment ActualDetailsTable_project on ProjectType {\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...DetailsTable_project\n}\n\nfragment BudgetData_project_1TK8ll on ProjectType {\n  ...Chart_project\n  ...HighLevelBudgetNumbers_project_1TK8ll\n  ...Totals_project\n  ...InvoiceChart_project\n  ...RevenueRecognition_project\n  id\n  billable\n  budgetType\n}\n\nfragment BudgetPageHeader_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  budgetType\n  budget\n  defaultPeriodBudgetType\n  rateCard {\n    currency\n    id\n  }\n  estimationUnit\n  billable\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n}\n\nfragment BudgetPage_project on ProjectType {\n  id\n  financialDataAvailability\n  ...BudgetPageHeader_project\n  ...BudgetData_project_1TK8ll\n  ...TimeBudgetData_project_1TK8ll\n  ...Details_project\n  ...InvoiceDetails_project\n  ...TimeDetails_project\n  ...ExpenseDetails_project\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  budgetType\n}\n\nfragment Chart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment DetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment Details_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  billable\n  ...DetailsTable_project\n  ...ActualDetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment ExpenseDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment ExpenseDetails_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  billable\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  ...ExpenseDetailsTable_project\n}\n\nfragment HighLevelBudgetNumbers_project_1TK8ll on ProjectType {\n  id\n  useBaseline\n  hasInvoices\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  timeRegBasedPlusDoneScopeCompletion\n  rateCard {\n    currency\n    id\n  }\n  financialNumbers(convertToProjectCurrency: true) {\n    baselineRevenue\n    actualRevenue\n    baselineProfit\n    actualProfit\n    totalRevenueProfitAtCompletion\n    baselineMargin\n    actualMargin\n    totalRevenueMarginAtCompletion\n    billableActualTimeAndExpenses\n    actualCost\n    billableForecastTimeAndExpensesToComplete\n    forecastCostToComplete\n    totalCostAtCompletion\n    billableTotalTimeAndExpensesAtCompletion\n    invoiced\n    paid\n    recognitionProfit\n    recognitionProfitPercentage\n    totalRevenueRecognition\n    projectTotalForecastTimeAndExpensesToCompleteInPast\n    projectTotalForecastCostToCompleteInPast\n    baselineCost\n    baselineVsForecastCost\n    allActualTimeAndExpenses\n    allForecastTimeAndExpensesToComplete\n    allTotalTimeAndExpensesAtCompletion\n    baselineTimeAndExpenses\n    baselineVsBillableTotalTimeAndExpensesAtCompletion\n    estimatedCost\n    planVsTotalCostAtCompletion\n    billablePlannedTimeAndExpenses\n  }\n  financialNumbersToCurrentMonth: financialNumbers(convertToProjectCurrency: true) {\n    recognitionLockedProfit\n    recognitionLockedProfitPercentage\n    recognitionLockedRevenue\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelTimeNumbers_project_1TK8ll on ProjectType {\n  id\n  useBaseline\n  billable\n  financialNumbersToCurrentMonth: financialNumbers(convertToProjectCurrency: true) {\n    registeredMinutes\n    billableActualMinutes\n    nonBillableActualMinutes\n    forecastMinutes\n    baselineMinutes\n    scopeApprovedMinutes\n    projectedTotalMinutes\n    projectedBillableMinutes\n    projectedNonBillableMinutes\n  }\n}\n\nfragment InvoiceChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetails_project on ProjectType {\n  ...InvoiceDetailsTable_project\n  budgetType\n}\n\nfragment RevenueRecognition_project on ProjectType {\n  id\n  budgetType\n  billable\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  estimationUnit\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        locked\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    currency\n    id\n  }\n}\n\nfragment TimeBudgetData_project_1TK8ll on ProjectType {\n  ...TimeChart_project\n  ...TimeTotals_project\n  ...HighLevelTimeNumbers_project_1TK8ll\n}\n\nfragment TimeChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment TimeDetails_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  ...DetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment TimeTotals_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment Totals_project on ProjectType {\n  id\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  useFixedPriceForBaselineRevenue\n}\n\nfragment expenseRow_project on ProjectType {\n  id\n  budgetType\n  companyProjectId\n}\n\nfragment expensesPage_project on ProjectType {\n  ...expenseRow_project\n  id\n  companyProjectId\n  billable\n  budgetType\n  status\n  rateCard {\n    id\n    currency\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        id\n        category {\n          id\n          name\n        }\n        phase {\n          id\n          name\n        }\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        cost\n        quantity\n        planned\n        createdAt\n        invoiced\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_project on ProjectType {\n  id\n  budget\n  budgetType\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  projectPersons(first: 1000) {\n    edges {\n      node {\n        id\n        person {\n          id\n          isViewer\n          fullName\n          initials\n          profilePictureId\n          profilePictureDefaultId\n          active\n          permissions\n          costPeriods(first: 10000) {\n            edges {\n              node {\n                id\n                startDay\n                startMonth\n                startYear\n                cost\n              }\n            }\n          }\n        }\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  rateCard {\n    id\n    currency\n    name\n    defaultRate\n    parentRateCardId\n    disabledRoles {\n      id\n    }\n    rates(first: 10000) {\n      edges {\n        node {\n          id\n          rate\n          defaultRate\n          startDate\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  invoices(first: 100000000) {\n    edges {\n      node {\n        status\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91040f741a5dc4661097a8038a46dd5b';

module.exports = node;
